import Card from '@mui/material/Card';
import { Link } from 'react-router-dom';
import { trackClickEvent } from '../../../utils/functions/trackEvent';
import { Course } from '../../../types/Course';
import ProfilePicture from '../../ProfileImage';
import { TeacherInfo } from '../../../types/TeacherInfo';
import Rate from '../../Rate';
import { teacherAdapter } from '../../../services/adapters/mappers/teachers';
import './RecentCourseCard.css';

const RecentCourseCard = ({ course, teacher }: { course: Course; teacher: TeacherInfo }) => {
  const handleTeacherClick = () => {
    trackClickEvent('recent_teacher_course_card', teacher.external_id);
    trackClickEvent('recent_course_card', course.label);
  };

  // Apply teacher adapter for staging random rates
  const adaptedTeacher = teacherAdapter(teacher);

  return (
    <Card className="recentCourseCard">
      <Link
        to={`/teachers/${teacher.external_id}/profile?courseId=${course.value}`}
        className="cardContent"
        onClick={() => handleTeacherClick()}>
        <div className="cardHeader">
          <h3 className="courseName">{course.label}</h3>
          <p className="institutionName">{course.institution.label}</p>
        </div>
        <div className="teacherInfoCard">
          <ProfilePicture image_url={adaptedTeacher.image_url} />
          <div>
            <div className="teacherName">
              {adaptedTeacher.first_name} {adaptedTeacher.last_name}
            </div>
            {adaptedTeacher.rate && adaptedTeacher.rate.average > 0 && (
              <Rate rate={adaptedTeacher.rate} />
            )}
          </div>
        </div>
      </Link>
    </Card>
  );
};

export default RecentCourseCard;
